import { css } from '@emotion/css';
import { Display, JustifyContent } from 'src/styles';

export const modalContentContainer = css`
  max-height: 750px;
  overflow: auto;
  overflow-x: hidden;
`;

export const justifyRightButton = css`
  ${JustifyContent.flexEnd}
  ${Display.flex}
`;

export const justifyLeftButton = css`
  ${JustifyContent.flexStart}
  ${Display.flex}
`;
